var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhitePostClickIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.553,
    height: 16.439,
    viewBox: "0 0 16.553 16.439",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-0.01 -0.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0.01 0.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59909",
    "data-name": "Path 59909",
    d: "M16.881,14.873l-2.77-2.77,1.974-1.144a.474.474,0,0,0,.237-.432.491.491,0,0,0-.3-.4L7.216,6.614a.457.457,0,0,0-.6.271.449.449,0,0,0,0,.33l3.515,8.81a.44.44,0,0,0,.4.3.457.457,0,0,0,.432-.237L12.1,14.111l2.77,2.77a.46.46,0,0,0,.652,0l1.355-1.347a.474.474,0,0,0,0-.661Z",
    transform: "translate(-1.015 -1.077)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59910",
    "data-name": "Path 59910",
    d: "M3.265,2.458a.6.6,0,1,0-.847.847L3.731,4.585a.6.6,0,1,0,.847-.847Z",
    transform: "translate(-0.351 -0.42)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59911",
    "data-name": "Path 59911",
    d: "M2.788,8.352a.542.542,0,0,0-.542-.542H.552a.542.542,0,1,0,0,1.084H2.246a.534.534,0,0,0,.542-.534Z",
    transform: "translate(-0.01 -1.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59912",
    "data-name": "Path 59912",
    d: "M3.3,11.708l-1.33,1.321a.6.6,0,0,0,.847.847l1.321-1.321a.6.6,0,0,0,0-.847.584.584,0,0,0-.839,0Z",
    transform: "translate(-0.283 -1.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59913",
    "data-name": "Path 59913",
    d: "M8.351,2.808a.542.542,0,0,0,.542-.534h0V.58A.551.551,0,0,0,7.8.555h0V2.249a.551.551,0,0,0,.551.559Z",
    transform: "translate(-1.201 -0.084)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59914",
    "data-name": "Path 59914",
    d: "M12.235,4.2a.491.491,0,0,0,.364-.152l1.152-1.152a.508.508,0,0,0,0-.72h0a.508.508,0,0,0-.728,0L11.862,3.307a.508.508,0,0,0,0,.729A.491.491,0,0,0,12.235,4.2Z",
    transform: "translate(-1.799 -0.38)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePostClickIcon);
export default __webpack_public_path__ + "static/media/white_post_click_icon.0f3059fffab06b0448e1c5ee8b01876c.svg";
export { ForwardRef as ReactComponent };